import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider, useLang } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Rail from "@/components/Rail";
import Hats from "@/components/Hats";
import Process from "@/components/Process";
import Paths from "@/components/Paths";
import Portfolio from "@/components/Portfolio";
import Trust from "@/components/Trust";
import ChatCards from "@/components/ChatCards";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Admin from "@/components/Admin";
import About from "@/components/About";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Seo from "@/components/Seo";

function Landing() {
  const { t } = useLang();
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-bone font-sans text-ink antialiased">
      <Seo title={t.seo.home.title} description={t.seo.home.description} />
      <Header />
      <main>
        <Hero />
        <Rail />
        <Hats />
        <Marquee />
        <Process />
        <Paths />
        <Portfolio />
        <Trust />
        <ChatCards />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LangProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </LangProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
